// extracted by mini-css-extract-plugin
export var errorsContainer = "_rx-1";
export var link = "_rx-0";